import {subscribeWishlist, unsubscribeWishlist} from "@/api/apiMethods.ts";
import {useWishlist} from "@/providers/WishlistProvider.tsx";
import {useState} from "react";
import {Button} from "@telegram-apps/telegram-ui";
import {TbBellMinus, TbBellPlus} from "react-icons/tb";
import {useNavigation} from "@/providers/NavigationProvider.tsx";
import {useTranslation} from "react-i18next";
import {haptic} from "@/helpers/haptic.ts";

export const SubscribeButton = () => {
  const { wishlist, setWishlist } = useWishlist();
  const [ isSubscriptionLoading, setSubscriptionLoading ] = useState(false);
  const { showSnackbar } = useNavigation();
  const { t } = useTranslation();

  if (!wishlist) {
    throw new Error("SubscriptionButton must be inside the WishlistLayout");
  }

  const toggleSubscribe = async () => {
    haptic.impact('light');
    setSubscriptionLoading(true);
    try {
      if (wishlist.isSubscribed) {
        await unsubscribeWishlist(wishlist.id);
        setWishlist({...wishlist, isSubscribed: false});
        haptic.notification('success');
        showSnackbar("🔕", "system.wishlistUnsubscribed");
      } else {
        await subscribeWishlist(wishlist.id);
        setWishlist({...wishlist, isSubscribed: true});
        haptic.notification('success');
        showSnackbar("🔔", "system.wishlistSubscribed");
      }
    } catch (e) {
      haptic.notification('error');
      showSnackbar("❌", "system.unknowError");
    }

    setSubscriptionLoading(false);
  }

  return (<>
    {!wishlist.isSubscribed &&
      <Button before={<TbBellPlus size={20} />}
              loading={isSubscriptionLoading}
              disabled={isSubscriptionLoading}
              onClick={toggleSubscribe}
              stretched={true}
              mode={"filled"}>
        {t('action.subscribe')}
      </Button>}
    {wishlist.isSubscribed &&
    <Button before={<TbBellMinus size={20} />}
            loading={isSubscriptionLoading}
            disabled={isSubscriptionLoading}
            onClick={toggleSubscribe}
            stretched={true}
            mode={"gray"}>
      {t('action.unsubscribe')}
    </Button>}
  </>);
}
